export enum FeatureFlag {
  VAX_LOC_IDS = "VAX_LOC_IDS",
  GROWTH_CACHED_SLOTS_ENABLED = "GROWTH_CACHED_SLOTS_ENABLED",
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  PASSWORDLESS_WEB_SCHEDULING_ENABLED = "PASSWORDLESS_WEB_SCHEDULING_ENABLED",
  WEB_SCHEDULING_LOGIN_LINKS_VIA_SMS_ENABLED = "WEB_SCHEDULING_LOGIN_LINKS_VIA_SMS_ENABLED",
}
